var _defs, _clipPath, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 1024 1024",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1024,
    width: 1024,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Capa-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71272 516.884C9.71272 236.051 235.651 8.39127 514.36 8.39127C793.07 8.39127 1019.01 236.051 1019.01 516.884C1019.01 797.717 793.07 1025.38 514.36 1025.38C235.651 1025.38 9.71272 797.717 9.71272 516.884Z",
    fill: "#90bdf9",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.889 655.921C266.729 655.921 285.769 649.142 303.831 644.297C329.589 637.386 355.091 632.349 381.568 629.04C412.217 625.209 443.118 623.499 473.835 620.322C498.292 617.792 522.734 614.555 547.213 612.33C596.026 607.892 645.093 605.861 693.969 602.159C729.743 599.449 764.713 594.053 800.04 588.355C807.916 587.085 816.027 585.829 824.015 585.449C826.676 585.322 830.566 583.208 832.006 585.449C833.858 588.33 831.679 592.385 830.553 595.62C828.324 602.029 822.525 606.576 818.929 612.33C803.991 636.232 794.327 663.054 781.15 687.887C753.497 740.004 719.193 787.344 672.173 823.746C657.558 835.06 641.965 845.588 624.95 852.806C617.263 856.067 608.986 857.715 600.975 860.071C592.518 862.559 584.152 865.424 575.547 867.336C557.47 871.354 540.31 873.205 521.785 872.422C499.066 871.462 478.359 864.58 457.125 857.165C447.651 853.857 437.961 851.069 428.791 846.994C384.787 827.436 350.309 796.374 316.182 763.445C302.873 750.603 289.128 738.131 276.95 724.213C266.739 712.543 256.427 700.832 247.889 687.887C244.25 682.37 241.974 676.04 238.445 670.451C236.142 666.806 233.707 663.109 230.453 660.28C228.001 658.148 224.641 657.374 221.735 655.921",
    fill: "#2e2626",
    fillOpacity: 0,
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.192 675.212L854.103 673.148",
    fill: "none",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.216 382.07C264.216 330.418 304.871 288.546 355.022 288.546C405.172 288.546 445.828 330.418 445.828 382.07C445.828 433.723 405.172 475.595 355.022 475.595C304.871 475.595 264.216 433.723 264.216 382.07Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.077 390.77C598.077 339.118 638.732 297.246 688.883 297.246C739.034 297.246 779.689 339.118 779.689 390.77C779.689 442.423 739.034 484.295 688.883 484.295C638.732 484.295 598.077 442.423 598.077 390.77Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 48.9634
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/Neutral.cfd119e77e5a0d706413b81b945eb9f5.svg";
export { ForwardRef as ReactComponent };